import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Result, Spin, Button, Typography } from "antd";
import api from "Common/Client/Interceptor";

const { Paragraph } = Typography;

const PaymentSuccessService = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const purchaseId = searchParams.get("purchaseId");

    const [loading, setLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [infoMessage, setInfoMessage] = useState("");

    useEffect(() => {
        if (!purchaseId) {
            setLoading(false);
            setInfoMessage("Invalid payment reference.");
            return;
        }

        pollPaymentStatus(purchaseId);
    }, [purchaseId]);

    const pollPaymentStatus = async (purchaseId) => {
        const interval = 2000; // 2 sec
        const maxRetries = 15; // ~30 sec
        let attempts = 0;

        while (attempts < maxRetries) {
            try {
                const res = await api.get(
                    `/indv/ExpertServicePurchase/verify-payment/${purchaseId}`
                );  

                if (res.data?.isPaymentSuccess === true) {
                    setIsSuccess(true);
                    setLoading(false);
                    return;
                }
            } catch (err) {
                console.error("Payment polling failed", err);
            }

            await new Promise((r) => setTimeout(r, interval));
            attempts++;
        }

        setLoading(false);
        setInfoMessage(
            "Payment is taking longer than usual. Your access will be granted once confirmed."
        );
    };

    if (loading) {
        return (
            <Result
                icon={<Spin size="large" />}
                title="Confirming Payment"
                subTitle="Please wait while we verify your transaction..."
            />
        );
    }

    if (isSuccess) {
        return (
            <Result
                status="success"
                title="Payment Successful 🎉"
                subTitle={`Purchase ID: ${purchaseId}`}
                extra={[
                    <Button
                        type="primary"
                        key="serices"
                        onClick={() => navigate("/selfLearner-dashboard")}
                    >
                        Go to My Dasboard
                    </Button>,
                ]}
            />
        );
    }

    return (
        <Result
            status="info"
            title="Payment Processing"
            subTitle={<Paragraph>{infoMessage}</Paragraph>}
            extra={[
                <Button key="refresh" onClick={() => window.location.reload()}>
                    Refresh
                </Button>,
            ]}
        />
    );
};

export default PaymentSuccessService;
